import { Section } from "@/react/components/Spaces/CustomizeSpaceFullPage/Section";
import { AllWorkflows } from "@circle-react/components/SettingsApp/Workflows/routes/AllWorkflows";

export const Workflows = () => (
  <Section>
    <AllWorkflows category="administrative" pageSize={4} />
  </Section>
);
